import * as uuid from "uuid";
import {getQtCatName} from "../../../../helpers/sqftQuotesHelper";
import workspaceControllers from "../workspaceControllers";

export class LineHandlesModel {
  shapeId;
  lineId;
  id;
  featureId;
  sharedFeatureName;
  qtCatName;
  partId;
  quantityInGroup;
  quantityGroup;
  handleV3dURL;
  handleH3dURL;
  isDisabledInPopup;

  constructor(shapeId,
              lineId,
              featureId,
              sharedFeatureName,
              id = uuid.v4(),
              qtCatName = null,
              partId = null,
              quantity = 1, // this is number of handles from the filters
              quantityInGroup = 0, // this is number of doors or drawers (not used)
              quantityGroup = null,
              handleV3dURL = null,
              handleH3dURL = null,
              isDisabledInPopup = false,
  ) {
    this.shapeId = shapeId;
    this.lineId = lineId;
    this.featureId = featureId;
    this.sharedFeatureName = sharedFeatureName;
    this.id = id;
    this.qtCatName = qtCatName ? qtCatName : getQtCatName();
    this.partId = partId;
    this.quantity = quantity;
    this.quantityInGroup = quantityInGroup;
    this.quantityGroup = quantityGroup;
    this.handleV3dURL = handleV3dURL;
    this.handleH3dURL = handleH3dURL;
    this.isDisabledInPopup = isDisabledInPopup;
  }

  changeFeature = (feature) => {
    this.featureId = feature.dbFeature.id;
    this.sharedFeatureName = feature.dbFeature.sharedFeatureName;
    this.handleV3dURL = workspaceControllers.handles.findGLBModel(feature.dbFeature.thirdPartyAR3DUrls, 'V');
    this.handleH3dURL = workspaceControllers.handles.findGLBModel(feature.dbFeature.thirdPartyAR3DUrls, 'H');
  }

  setIsDisabledInPopup = (value) => {
    this.isDisabledInPopup = value;
  }
}
